import { Grid } from "@mui/material";
import HyPETCanvas from "./CanvasComponent/HyPETCanvas";
import ClampUnitCanvas from "./CanvasComponent/ClampUnitCanvas";
import InjectionUnitCanvas from "./CanvasComponent/InjectionUnitCanvas";

const MachineCanvas = ({
  hoveredPart,
  setHoveredPart,
  selectedAsset,
  machineName,
  navigationState,
}: any) => {
  const renderCanvas = () => {
    switch (selectedAsset) {
      case "Injection Unit":
        return (
          <HyPETCanvas
            hoveredPart={hoveredPart}
            setHoveredPart={setHoveredPart}
            machineName={machineName}
            navigationState={navigationState}
          />
        );
      case "Transfer Cylinder":
        return (
          <InjectionUnitCanvas
            hoveredPart={hoveredPart}
            setHoveredPart={setHoveredPart}
            machineName={machineName}
            navigationState={navigationState}
          />
        );
      case "Stationary Platen":
        return (
          <ClampUnitCanvas
            hoveredPart={hoveredPart}
            setHoveredPart={setHoveredPart}
            machineName={machineName}
            navigationState={navigationState}
          />
        );
      case "Mold":
        return (
          <ClampUnitCanvas
            hoveredPart={hoveredPart}
            setHoveredPart={setHoveredPart}
            machineName={machineName}
            navigationState={navigationState}
          />
        );
      case "Feed Throat":
        return (
          <InjectionUnitCanvas
            hoveredPart={hoveredPart}
            setHoveredPart={setHoveredPart}
            machineName={machineName}
            navigationState={navigationState}
          />
        );
    }
  };

  return <Grid container>{renderCanvas()}</Grid>;
};

export default MachineCanvas;
